import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CentrosModel, CentrosSearchResponse } from 'src/app/pages/configuracion/maestros/centros/models/centros-model';
import { environment } from 'src/environments/environment';
import { IRecuperarCentrosService } from './ports/i-recuperar-centros-service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { EmpresasModel } from '../../empresas/models/empresas-model';
import { FiltroBasico } from 'src/app/shared/models/filtros';



@Injectable({
  providedIn: 'root'
})
export class RecuperaCentrosMockService implements IRecuperarCentrosService{

  constructor(private http: HttpClient) { }

  guardaCentro(data: any): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getCentros(filtros: FiltroBasico[], pageNumber:number, orden?: OrdenColumna): Observable<CentrosModel[]> {
    const headers = new HttpHeaders()
      .set('content-type', 'application/json')
      let url;
      if(pageNumber == 0){ url = environment.ApiCentrosMock1; }
      if(pageNumber == 1){ url = environment.ApiCentrosMock1; }
      else if(pageNumber == 2){ url = environment.ApiCentrosMock2; }
      else if(pageNumber == 3){ url = environment.ApiCentrosMock3; }
      else if(pageNumber == 4){ url = environment.ApiCentrosMock4; }
      else if(pageNumber == 5){ url = environment.ApiCentrosMock5; }
      else if(pageNumber == 6){ url = environment.ApiCentrosMock6; }

      return this.http.get<CentrosModel[]>(url, {headers})
        .pipe(
          map(resp => {
            let centros: CentrosModel[] = resp;
              return centros;
            }
          )
      );
  }

  guardaCentros(data: CentrosModel[]): Observable<void> {
    return of(null);
  }

  deleteCentro(data: CentrosModel): Observable<void> {
    throw new Error('Method not implemented.');
  }

}
